import { render, staticRenderFns } from "./LinkedWorkItemsItem.vue?vue&type=template&id=9855c948&scoped=true"
import script from "./LinkedWorkItemsItem.vue?vue&type=script&lang=js"
export * from "./LinkedWorkItemsItem.vue?vue&type=script&lang=js"
import style0 from "./LinkedWorkItemsItem.vue?vue&type=style&index=0&id=9855c948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9855c948",
  null
  
)

export default component.exports